module.exports = function ensureCSSUnit(measurement, defaultUnit = 'px') {
  if (String(parseFloat(measurement, 10)) === String(measurement).trim()) {
    return `${String(measurement).trim()}${defaultUnit}`;
  }
  return measurement;
};
